import React from 'react'
import './styles/featurecardright.css';

const FeatureCardRight = ({ icon, title, description, bgColor, borderColor }) => {
  return (
    <div className="feature-card-right" style={{ border: `1px solid ${borderColor}` }}>
      <div className="feature-content-right">
        <h3 className="feature-title-right">{title}</h3>
        <p className="feature-description-right">{description}</p>
      </div>
      <div className="feature-icon-right" style={{ background: bgColor }}>
        <img src={icon} alt="Feature Icon" />
      </div>
    </div>
  )
}

export default FeatureCardRight